<template>
    <div class="heroCont">
        <div class="hero">

            <div class="contentZone">
                <slot name="content"></slot>
            </div>
            <div class="imgCont" :style="{ backgroundImage: holdBackground }">
                <slot name="background"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
interface Props {
    holdBackground?: string
}
withDefaults(defineProps<Props>(), {
    holdBackground: 'transparent'
})
</script>

<style lang="scss" scoped>
.heroCont {
    padding: var(--margin-gap);

    //transition: padding 150ms 0ms ease-in-out;

    .hero {
        position: relative;

        background-color: var(--color-background-image);
        min-height: var(--size-hero-minheight);
        max-width: var(--size-hero-max);
        border-radius: var(--size-hero-radius);

        margin: 0 auto;
        overflow: hidden;

        display: flex;


        //transition: border-radius 150ms 0ms ease-in-out, min-height 150ms 0ms ease-in-out;

        .contentZone {
            position: relative;
            z-index: 1;
            padding: calc(var(--margin-header) * 2 - 10px);
            padding-top: var(--size-hero-safetop);
            box-sizing: border-box;
            width: 100%;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            gap: var(--margin-mini);
        }

        .imgCont {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 0;

            transform: translateZ(0)
        }
    }
}

@media screen and (max-width: 1360px) {
    .heroCont {
        .hero {

            .contentZone {
                padding: var(--size-hero-safetop) 20px 20px 20px;
                max-width: 1200px;
                margin: 0 auto;
            }
        }
    }
}

@media screen and (max-width: 1279px) {
    .heroCont {
        padding: 0 0 var(--margin-gap) 0;

        .hero {
            border-radius: 0;
            min-height: calc(var(--size-hero-minheight) + 10px);
        }
    }
}

@media screen and (max-width: 600px) {
    .heroCont {
        .hero {
            min-height: 0;

            .contentZone {
                padding: 50vh var(--margin-page) var(--margin-page) var(--margin-page);

            }
        }
    }
}
</style>